import script from "./TabBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBarItem.vue?vue&type=script&setup=true&lang=js"

import "./TabBarItem.vue?vue&type=style&index=0&id=2c08fd92&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c08fd92"]])

export default __exports__